import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export const MOBILE_APP_PROMO_DISMISSED_KEY = 'mobileAppPromoDismissed';

@Component({
  selector: 'app-mobile-app-promo',
  templateUrl: './mobile-app-promo.component.html',
  styleUrls: ['./mobile-app-promo.component.scss']
})
export class MobileAppPromoComponent {
  // TODO: replace with the production store URLs when available
  appStoreUrl = 'https://apps.apple.com/ca/app/trakr-counting/id1619348130';
  playStoreUrl = 'https://play.google.com/store/apps/details?id=com.trakrsuite.counting';

  constructor(public dialogRef: MatDialogRef<MobileAppPromoComponent>) {}

  close(): void {
    localStorage.setItem(MOBILE_APP_PROMO_DISMISSED_KEY, '1');
    this.dialogRef.close();
  }
}
